import React from 'react';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import Button from '../../helpers/Button';

const FarmGalleryCard = ({ crop, activityTitle, task }) => {
  return (
    <>
      {!isEmpty(task.album) && (
        <div className="w-full md:w-4/5 lg:w-3/5 bg-white rounded px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="hidden md:block h-16 w-16 overflow-hidden rounded-full border-2 border-gray-600 xl:border-gray-300 my-3">
                <img
                  src={crop.imageUrl}
                  alt={crop.name}
                  className="inline-block h-full w-full object-cover"
                />
              </div>
              <div className="ml-6">
                <h5 className="border-b-2 border-green-600 text-sm md:text-base uppercase">
                  {activityTitle}
                </h5>
                <span className="block text-sm pt-2">{moment(task.updatedAt).fromNow()}</span>
              </div>
            </div>

            <div>
              <Button
                className="border-2 border-cf-300 text-cf-300 rounded px-3 md:px-6 py-1 md:py-2 focus:outline-none text-xs md:text-base"
                name={task.title}
              />
            </div>
          </div>

          <div className="flex flex-wrap mt-10">
            {task.album.map((url, index) => (
              <div className="w-1/2 p-2" key={index}>
                <Zoom zoomMargin={40}>
                  <img
                    src={url}
                    alt={task.title}
                    className="inline-block h-full w-full object-cover"
                  />
                </Zoom>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FarmGalleryCard;
